<template>
  <v-card
    elevation="0"
    outlined
    class="rounded-xl"
  >
    <v-card-title v-once id="topElement" class="py-6">
      Рейтинг по университету
    </v-card-title>
    <v-data-table
      style="min-width: 100%"
      :headers="headers"
      :items="rating"
      item-key="id"
      :loading="loadingRating"
      :page.sync="page"
      :items-per-page.sync="itemsPerPage"
      hide-default-footer
      hide-default-header
      mobile-breakpoint="0"
    >
      <template #header="{ props: { headers } }">
        <thead class="v-data-table-header" v-once>
        <tr>
          <th
              v-for="header in headers"
              :key="header.value"
              class="text-uppercase"
              scope="col"
          >
            {{ header.text }}
          </th>
        </tr>
        </thead>
      </template>
      <template #item="{ item }">
        <tr :id="rating.indexOf(item)">
          <td>
            <v-icon x-small :color="colorTrophy(item)">fa fa-trophy</v-icon>
            {{ rating.indexOf(item) + 1 }}
          </td>
          <td>{{item.full_name}}</td>
          <td><v-icon x-small>fa fa-university</v-icon> {{item.department}}</td>
          <td><v-icon x-small>fa fa-users</v-icon> {{item.group}}</td>
          <td><v-icon x-small>fa fa-star</v-icon> {{item.sum_score}}</td>
        </tr>
      </template>
      <template #loading>
        Идет загрузка рейтинга...
      </template>
    </v-data-table>
    <v-divider v-if="numberOfPages > 1"/>
    <v-card-actions v-if="numberOfPages > 1">
      <v-row
          class="pb-5 px-4 pt-5"
          align="center"
          justify="center">
        <div class="text-center">
          <v-pagination
              circle
              :color="$store.state.achievement.side_color"
              v-model="page"
              :length="numberOfPages"
              :total-visible="$vuetify.breakpoint.mdAndUp ? 12 : 1">
          </v-pagination>
        </div>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import {mapActions, mapState} from "vuex";
import _ from 'lodash'
import PrtfPortfolioApi from "../Services/Api/PrtfPortfolioApi";

export default {
  name: "RatingTab",

  mounted() {
    this.getRating();
  },

  data() {
    return {
      rating: [],
      loadingRating: true,
      headers: [
        {
          text: 'Место',
          value: 'number',
          groupable: false,
          sortable: false,
          width: '5%',
        },
        {
          text: 'ФИО',
          value: 'full_name',
          groupable: false,
          sortable: false,
          width: '20%',
        },
        { text: 'Факультет', value: 'department', width: '10%', sortable: false},
        { text: 'Группа', value: 'group', width: '10%', sortable: false},
        // {text: 'Количество', value: 'count', width: '10%', sortable: false},
        { text: 'Баллы', value: 'sum_score', sortable: false, width: '10%'},
      ],
      itemsPerPage: 25,
      page: 1,
    };
  },

  computed: {
    ...mapState({
      person_id: state => state.portfolio.portfolioPerson.person.id,
    }),

    numberOfPages () {
      return Math.ceil(this.rating.length / this.itemsPerPage)
    },

    // currentRating() {
    //   return _.find(this.rating, (i) => {return i.id === this.person_id})
    // },

  },

  watch: {
    'page': function () {
      this.scrollTop();
    },
  },

  methods: {

    updateItemsPerPage (number) {
      this.itemsPerPage = number
    },

    scrollTop() {
      const element = document.getElementById("topElement");
      element.scrollIntoView({behavior: "smooth"});
    },

    toPerson() {
      const index = this.rating.indexOf(this.currentRating);
      this.page = Math.ceil((index + 1)/25);
      // const [el] = document.getElementById(`${index}`);
      // console.log(el);
      // if (!el) el[0].scrollIntoView({ behavior: "smooth" });
    },

    colorTrophy(item) {
      switch (this.rating.indexOf(item)) {
        case 0:
          return "#D4AF37"
        case 1:
          return "#c0c0c0"
        case 2:
          return "#cd7f32"
      }
      // if (this.currentRating.person.id === item.person.id) return '#00796b'
      // else return ""
    },

    fullName(person) {
      try {
        let fullname = person.surname + " " + person.name[0] + "."
        if (person?.patronymic !== null && person?.patronymic !== "") fullname += person.patronymic[0] + "."
        return fullname
      } catch (e) {
        console.log(e);
        console.log(person)
      }
    },

    async getRating() {
      const response = await PrtfPortfolioApi.getRatingPortfolios();

      if (!response.data.hasOwnProperty("error")) {
        this.rating = response.data.rating_portfolios;
      }

      this.loadingRating = false;
    },

  },
}
</script>

<style scoped>

/deep/.show-person-place {
  border-bottom: 2px #00796b solid !important;
  cursor: pointer;
}

.v-data-table-header th {
  overflow: auto;
  background-color: #EEEEEE;
  text-transform: uppercase;
}

</style>